module.exports = __webpack_public_path__ + "static/media/style.887a2335.less";